<ng-container *ngIf="!isLoading else loading">
	<div class="card-title">
		<span translate>order-tracking.card.delivery-status</span>
	</div>
	<div class="delivery-block-portal">
		<ng-container *ngFor="let order of orders; let i = index">
			<div class="delivery-card">
				<div class="delivery-header">
					<div class="delivery-header-left">
						<mat-icon color="accent" svgIcon="ordered" class="delivery-header-margin-right delivery-mat-icon"></mat-icon>
						<a class="delivery-header-margin-right delivery-header-link"
						[routerLink]="['/order-tracking/order/card/', order.supplierOrderNumber, order.supplierOrderItemNumber]">
							{{getOrderName(order)}}
							<div class="delivery-header-margin-right" >{{ getProductName(order) }}</div>
						</a>
					</div>
					<div class="pill delivery-header-right"
					[ngClass]="{'delivery-is-delayed':  getDeliveryStatus(order) === 'delivery.status.late',
					'delivery-status-on-time': getDeliveryStatus(order) === 'delivery.status.on-time'}">
						<span class="delivery-status-label" translate> {{ getDeliveryStatus(order) }} </span>
					</div>
				</div>
				<div class="delivery-content">
					<div class="delivery-container-column">
						<span class="delivery-content-label" translate>order-tracking.card.delivery-date.rdd</span>
						<span class="delivery-content-date">{{order.rddWeek | copoDate:'week'}}</span>
					</div>
					<div class="delivery-container-column delivery-column-center">
						<span class="delivery-content-label" translate>order-tracking.card.delivery-date.cdd</span>
						<span class="delivery-content-date">{{ checkCddWeekDataWithDatePipe(order) }}</span>
					</div>
					<div class="delivery-container-column delivery-column-center">
						<span class="delivery-content-label" translate>order.first.batch.in.stock</span>
						<span class="delivery-content-date">{{ order.grossFirstBatchInStock ? (order.grossFirstBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
					</div>
					<div class="delivery-container-column delivery-column-end">
						<span class="delivery-content-label" translate>order.last.batch.in.stock</span>
						<span  class="delivery-content-date">{{ order.grossLastBatchInStock ? (order.grossLastBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="delivery-block-mobile">
		<ng-container *ngFor="let order of orders; let i = index">
			<div class="delivery-card">
				<div class="delivery-header">
					<div class="pill delivery-header-right"
					[ngClass]="{'delivery-is-delayed':  getDeliveryStatus(order) === 'delivery.status.late',
					'delivery-status-on-time': getDeliveryStatus(order) === 'delivery.status.on-time'}">
						<span class="delivery-status-label" translate> {{ getDeliveryStatus(order) }} </span>
					</div>
					<div class="delivery-header-left">
						<mat-icon color="accent" svgIcon="ordered" class="delivery-header-margin-right delivery-mat-icon"></mat-icon>
						<a class="delivery-header-margin-right delivery-header-link"
						[routerLink]="['/order-tracking/order/card/', order.supplierOrderNumber, order.supplierOrderItemNumber]">
						{{ getOrderName(order) }}
							<div class="delivery-header-margin-right" >{{ getProductName(order) }}</div>
						</a>
					</div>
				</div>
				<div class="delivery-content">
					<div class="delivery-container-column delivery-column-center">
						<span class="delivery-content-label" translate>order.first.batch.in.stock</span>
						<span class="delivery-content-date">{{ order.grossFirstBatchInStock ? (order.grossFirstBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
					</div>
					<div class="delivery-container-column delivery-column-end">
						<span class="delivery-content-label" translate>order.last.batch.in.stock</span>
						<span  class="delivery-content-date">{{ order.grossLastBatchInStock ? (order.grossLastBatchInStock | copoDate:'week') : UNDERSCORE }}</span>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
	<div class="card-block-footer mobile-hide">
		<button type="button" mat-button color="primary" (click)="viewDetails()">
			<span translate>order-tracking.card.delivery-date.view-details</span>
			<mat-icon iconPositionEnd color="accent" svgIcon="md:chevron_right"></mat-icon>
		</button>
	</div>
</ng-container>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
